import { Disclosure } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';

import React from 'react';

import { createTitleComponent } from '../../helpers/createTitleComponent';

const faqsContent = [
  {
    id: 1,
    question: 'But what actually is GolfLists.com?',
    answer:
      'GolfLists.com is a massive database of local golf insights shared by a network of British and Irish golf club members!',
  },
  {
    id: 2,
    question: 'What is the vision for GolfLists.com?',
    answer:
      'To become the go to community for British and Irish Golf Club members to connect and share or access insider golf insights.',
  },
  {
    id: 3,
    question: 'What makes GolfLists.com different to other golf sites?',
    answer:
      'GolfLists.com is focussed on connection, providing user tools and comparison of objective information; rather than visitor reviews.',
  },
  {
    id: 4,
    question: 'Can I partner with, or write about GolfLists.com?',
    answer:
      'For partnership, press or general enquiries, please contact us via the contact page.',
  },
  {
    id: 5,
    question: 'How does GolfLists.com collect its data?',
    answer:
      'GolfLists.com collects golf course information through crowdsourced inputs to our datasets and through manual data entry by our research team.',
  },
  {
    id: 6,
    question: 'Who started GolfLists.com?',
    answer:
      'GolfLists.com got its start when planning a golf trip to Scotland required opening 15+ websites—we built it so golfers would have a single place to find and compare the information they need.',
  },
];

export default function Faqs({ level }) {
  return (
    <div className="bg-white py-6 sm:py-10">
      <div className="w-11/12 mx-auto">
        <div className="bg-white rounded-2xl shadow-xl ring-1 ring-slate-200/80 p-6 sm:p-8">
          <div className="mx-auto max-w-2xl text-center">
          {createTitleComponent(
            level,
            'FAQs',
            'mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl',
          )}
          <p className="mt-6 text-base leading-7 text-gray-600">
            Have a different question? Reach the team by sending us an email and
            we will get back to you as soon as we can.
          </p>
          </div>

          <div className="mt-8 mx-auto max-w-3xl divide-y divide-slate-200">
            {faqsContent.map((faq) => (
              <Disclosure key={faq.id} as="div" className="py-3">
                {({ open }) => (
                  <>
                    <Disclosure.Button className="w-full flex items-center justify-between gap-4 text-left">
                      <span className="text-sm sm:text-base font-semibold text-slate-900">
                        {faq.question}
                      </span>
                      <ChevronDownIcon
                        className={`h-5 w-5 text-slate-500 transition-transform ${
                          open ? 'rotate-180' : ''
                        }`}
                      />
                    </Disclosure.Button>
                    <Disclosure.Panel className="mt-2 text-sm sm:text-base text-slate-600 leading-7">
                      {faq.answer}
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
